import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { gql, useQuery } from '@apollo/client';
import { ThemeProvider } from "styled-components";
import { Theme, GlobalStyle } from "./styles/Theme";

import { MainLayout } from "./componentes/MainLayout";
import LoaderRing from "./componentes/LoaderRing";
import TheMenu from "./componentes/Menu";
import UpdateOverlay from "./componentes/UpdateOverlay";

const Home = lazy(() => import("./pantallas/Home"));
const Ventas = lazy(() => import("./pantallas/Ventas"));
const Inicio = lazy(() => import("./pantallas/Inicio"));
const Admin = lazy(() => import("./pantallas/Admin"));
const VisionGlobal = lazy(() => import("./pantallas/VisionGlobal"));
const NoVentas = lazy(() => import("./pantallas/noventas"));
const AnalisisAvanzado = lazy(() => import("./pantallas/AnalisisAvanzado"));
const HomeBma = lazy(() => import("./bma/index"));
const Marketing = lazy(() => import("./pantallas/Marketing"));
const LogInPage = lazy(() => import("./pantallas/LogIn"));
const Novedades = lazy(() => import("./pantallas/Novedades"));
const Coberturas = lazy(() => import("./pantallas/Coberturas"));
const HistoricosAdmin = lazy(() => import("./pantallas/HistoricosAdmin"));
const HistoricoAnalisisRuta = lazy(() => import("./pantallas/HistoricoAnalisisRuta"));
const HistoricoAnalisisRegion = lazy(() => import("./pantallas/HistoricoAnalisisRegion"));
const HistoricoAnalisisRegionAlt = lazy(() => import("./pantallas/HistoricoAnalisisRegionAlt"));
const Covid = lazy(() => import("./pantallas/Covid19"));
const Video = lazy(() => import("./pantallas/Video"));
const VideoCursoExcel = lazy(() => import("./pantallas/VideoCursoExcel"));
const FindLeads = lazy(() => import("./pantallas/FindLeads"));
const Ayuda = lazy(() => import("./pantallas/Ayuda"));
const ForgotPassword = lazy(() => import("./pantallas/ForgotPassword"));
const ResetPassword = lazy(() => import("./pantallas/ResetPassword"));
const Prospeccion2026 = lazy(() => import("./pantallas/Prospeccion2026"));
const GestionUsuarios = lazy(() => import("./pantallas/GestionUsuarios.tsx"));
const GestionVehiculos = lazy(() => import("./pantallas/GestionVehiculos.tsx"));
const DespachoRutas = lazy(() => import("./pantallas/DespachoRutas"));
const DistribucionVendedores = lazy(() => import("./pantallas/DistribucionVendedores"));
const DespachoEjecucion = lazy(() => import("./pantallas/DespachoEjecucion"));
const MonitorTareas = lazy(() => import("./pantallas/MonitorTareas"));

const ISLOGGEDIN = gql`
  {
    isLoggedIn @client
  }
`;

const PrivateRoute = ({ element: Component }) => {
  const { data } = useQuery(ISLOGGEDIN);
  return data && data.isLoggedIn ? Component : <Navigate to="/login" replace />;
};

const App = () => {
  return (
    <ThemeProvider theme={Theme}>
      <React.Fragment>
        <GlobalStyle />
        <UpdateOverlay />
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <div id="app-container">
            <TheMenu />
            <Suspense fallback={<LoaderRing texto="Iniciando Módulo..." />}>
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Inicio />} />
                <Route path="/login" element={<LogInPage />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/marketing" element={<Marketing />} />
                <Route path="/video" element={<Video />} />
                <Route path="/videocursoexcel" element={<VideoCursoExcel />} />
                <Route path="/novedades" element={<Novedades />} />
                <Route path="/ayuda" element={<Ayuda />} />

                {/* Private Routes with MainLayout Shell */}
                <Route element={<PrivateRoute element={<MainLayout />} />}>
                  <Route path="/ventas" element={<Ventas />} />
                  <Route path="/despacho" element={<DespachoRutas />} />
                  <Route path="/vendedores" element={<DistribucionVendedores />} />
                  <Route path="/despacho/ejecucion" element={<DespachoEjecucion />} />
                  <Route path="/coberturas" element={<Coberturas />} />
                  <Route path="/explorar" element={<Home />} />
                  <Route path="/findleads" element={<FindLeads />} />
                  <Route path="/analisis-avanzado" element={<AnalisisAvanzado />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="/vision" element={<VisionGlobal />} />
                  <Route path="/noventas" element={<NoVentas />} />
                  <Route path="/covid19" element={<Covid />} />
                  <Route path="/historicosAdmin" element={<HistoricosAdmin />} />
                  <Route path="/historicoAnalisisRuta" element={<HistoricoAnalisisRuta />} />
                  <Route path="/historicoAnalisisRegion" element={<HistoricoAnalisisRegion />} />
                  <Route path="/historicoAnalisisRegionAlt" element={<HistoricoAnalisisRegionAlt />} />
                  <Route path="/prospeccion-2026" element={<Prospeccion2026 />} />
                  <Route path="/admin/usuarios" element={<GestionUsuarios />} />
                  <Route path="/admin/vehiculos" element={<GestionVehiculos />} />
                  <Route path="/monitor-tareas" element={<MonitorTareas />} />
                  <Route path="/bma/*" element={<HomeBma />} />
                </Route>
                
                {/* Fallback redirect */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Suspense>
          </div>
        </BrowserRouter>
      </React.Fragment>
    </ThemeProvider>
  );
};

export default App;
